/* eslint-disable no-use-before-define */
import TextField from "@material-ui/core/TextField";
import Autocomplete, {
	createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import React, { forwardRef, useImperativeHandle } from "react";

const filter = createFilterOptions();

const SelectionCombo = forwardRef((props, ref) => {
	console.log("props=", props.options);
	//console.log("top100Films=", top100Films);

	const [value, setValue] = React.useState(null);

	const [textError, setTextError] = React.useState();

	const handleNewValue = (newvalue) => {
		console.log("handleNewValue newvalue", newvalue);
		props.setUserTitleValue(newvalue);
	};

	const showError = (error) => {
		console.log("SelectionCombo error=", error);
		setTextError(error ? { error: true, id: "outlined-error" } : {});
	};

	useImperativeHandle(ref, () => {
		return { showError: showError };
	});

	return (
		<Autocomplete
			value={value}
			onChange={(event, newValue) => {
				// Create a new value from the user input
				if (newValue && newValue.inputValue) {
					setValue({
						title: newValue.inputValue,
					});

					return;
				}
				handleNewValue(newValue);

				setValue(newValue);
			}}
			filterOptions={(options, params) => {
				const filtered = filter(options, params);

				// Suggest the creation of a new value
				/*
				if (params.inputValue !== "") {
					filtered.push({
						inputValue: params.inputValue,
						title: `Add "${params.inputValue}"`,
					});
                }
                */

				return filtered;
			}}
			selectOnFocus
			id="free-solo-with-text-demo"
			options={props.options}
			getOptionLabel={(option) => {
				// Value selected with enter, right from the input
				if (typeof option === "string") {
					return option;
				}
				// Add "xxx" option created dynamically
				if (option.inputValue) {
					return option.inputValue;
				}
				// Regular option

				return option.title;
			}}
			renderOption={(option) => option.title}
			style={{ width: 300 }}
			freeSolo
			renderInput={(params) => (
				<TextField
					{...params}
					label={props.title}
					variant="outlined"
					{...textError}
				/>
			)}
		/>
	);
});

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

export default SelectionCombo;
